<section class="mt-26 ml-28 mr-8 h-full">
  <app-user-search-bar
    [userType]="listUserType"
    [placeholder]="literalService.get(listUserType === userType.Driver ? 'users.searchDriver' : 'users.search', true)"
    [searching]="searching"
    [searchValue]="searchValue"
    (addUserEventEmitter)="addUser()"
    (addUserDriverEventEmitter)="addUserDriver()"
    (filter)="filterUsers($event)"
    (changeUserTypeEmitter)="changeUserType($event)"
    (searchEventEmitter)="searchUsers($event)"
    (sort)="sortUsers()"
    (onChangePaginationSize)="handleChangePaginationSize($event)"
  ></app-user-search-bar>
  <div class="grid grid-cols-9 mt-6 mb-4 text-center">
    <label class="ml-14 flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.user.account" alt="name" class="h-6 w-6 mr-2" />
      {{ literalService.get("users.data.name", true) }}
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.user.mail" alt="mail" class="h-6 w-6 mr-2" />
      {{ literalService.get("users.data.mail", true) }}
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.user.phone" alt="phone" class="h-6 w-6 mr-2" />
      {{ literalService.get("users.data.phone", true) }}
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.user.id" alt="id" class="h-6 w-6 mr-2" />
      {{ literalService.get("users.data.dni", true) }}
    </label>
    <label class="flex justify-center col-span-1 font-semibold text-base">
      <img [src]="images.moreOptions" alt="moreOptions" class="h-6 w-6 mr-2" />
      {{ literalService.get("moreOptions", true) }}
    </label>
  </div>
</section>
<section class="mt-5 h-full">
  <div id="usersContainer" class="scrollable-content max-h-[calc(100vh-310px)] h-full ml-25 mr-5 px-3 mb-5" >
    @if (!users.isFetchingUsers) {  
      @for (user of users.value; track $index) {
        <a
          id="{{'user'+user.id}}"
          class="userRow selectable-row border rounded pt-2 pb-2 grid grid-cols-9 justify-center items-center mb-4"
          [class.selected-row]="userSelected?.id === user.id"
          [ngClass]="{ 'inactive': user.status?.toUpperCase() === userStatus.INACTIVE, 'blocked': user.status?.toUpperCase() === userStatus.BLOCKED, 'deleted': user.status?.toUpperCase() === userStatus.DELETED  }"
          href="{{ `${listBasePath}/${user.id}` }}"
          (click)="$event.preventDefault()"
        >
          <label [id]="'name-'+user.id" class="truncate pr-5 pl-5 ml-14 col-span-2 text-base cursor-pointer" [tooltip]="utilsService.visibleTooltip('name-'+user.id!) ? user.firstName + ' ' + user.lastName : ''" [visibleTooltip]="utilsService.visibleTooltip('name-'+user.id!)" [position]="TooltipPosition.DYNAMIC" (click)="showUserData(user.id)">
            {{ user.firstName }} {{ user.lastName }}
          </label>
          <label [id]="'email-'+user.id" class="truncate pr-5 pl-5 col-span-2 text-base cursor-pointer" [tooltip]="utilsService.visibleTooltip('email-'+user.id!) ? user.email! : ''" [visibleTooltip]="utilsService.visibleTooltip('email-'+user.id!)" [position]="TooltipPosition.DYNAMIC" (click)="showUserData(user.id)">
            {{ user.email || "-" }}
          </label>
          <label class="truncate pr-5 pl-5 col-span-2 text-base cursor-pointer" (click)="showUserData(user.id)">
            {{ user.phone || "-" }}
          </label>
          <label class="truncate pr-5 pl-5 col-span-2 text-base cursor-pointer" (click)="showUserData(user.id)">
            {{ $any(user).dni || "-" }}
          </label>
          <div class="flex justify-center cursor-default">
            <img [src]="images.trips.date" alt="calendar" class="h-6 w-6 mr-6 cursor-pointer" [tooltip]="literalService.get('users.tooltips.bookings' , true)" [position]="TooltipPosition.DYNAMIC" (click)="userBookings.showViewBookingsModal(user.id)" />
            @if (user?.type !== userType.Driver) {
              <img [src]="images.user.star" alt="favorite" class="h-6 w-6 cursor-pointer" [tooltip]="literalService.get('users.tooltips.favoriteRoutes' , true)" [position]="TooltipPosition.DYNAMIC" (click)="showFavouriteRoutes($event, user.id!)" [ngClass]="" />
            }
            @else {
              <img [src]="images.user.star" alt="disabledFavorite" class="h-6 w-6 filter-neutrals-grey-02" />
            }
          </div>
        </a>
      }
    } @else {
      <ngx-skeleton-loader [count]="users.pagination.size || 10" appearance="line" [theme]="{ 'height': '40px' }"></ngx-skeleton-loader>
    }
  </div>
  @if (users.value.length > 0 || users.isFetchingUsers) {
    <section class="h-14">
      <app-pagination [pagination]="users.pagination" [loading]="users.isFetchingUsers && !users.pagination.totalPages" [baseUrl]="'/users'" (changePage)="changePage($event)" />
    </section>
  }
  @if (userSelected || newUser) {
    <app-user-details [class.hidden]="ticketDrawer.isNewTicketOpen" [user]="userSelected || newUser" [listUserType]="listUserType" [restoreUserBookingsFromUrl]="false" [newUser]="newUser" (userEdited)="userEdited($event)" (closeDetails)="closeDetails()" (showFavourites)="showFavouriteRoutes($event, userSelected.id!)" (showDocumentsModalEventEmitter)="showDocumentsModal()" (showActivePassesModalEventEmitter)="showActivePassesModal($event)" (openTicket)="ticketDrawer.open($event)"></app-user-details>
    <app-ticket-drawer [request]="ticketDrawer.request" (closed)="ticketDrawer.close()" />
  }
  <app-modal-favourite-routes [id]="'viewFavouritesUsers'" [modal]="viewFavouritesUsers" [hidden]="!viewFavouritesShowed" [favourites]="favourites" [recurrents]="recurrents" (book)="bookWithFavourite($event)" (edit)="editFavourite($event)" (delete)="deleteFavourite($event)" (editRecurrent)="editRecurrent($event)" (deleteRecurrent)="deleteRecurrent($event)" (goToNewFavouriteEmitter)="goToNewFavourite()" [isFromUser]="true" (changePaginationEmitter)="onFavouriteChangePage($event)" (changeFavouriteType)="onFavouriteTypeChange($event)"></app-modal-favourite-routes>
</section>
<app-user-bookings-modal #userBookings [id]="'viewBookings'" />
<app-modal-update-documents [id]="'updateDocuments'" [user]="userSelected" [modal]="updateDocuments" [uploading]="true" [hidden]="!updateDocumentsShowed" [documents]="documents" (uploadDocuments)="onUploadDocuments($event)" (deleteAction)="deleteDocument($event)" (downloadDocument)="downloadDocument($event)"/>
<app-modal-active-passes [id]="'activePasses'" [modal]="activePasses" [hidden]="!activePassesShowed" [userId]="activePassesUserId" [allowedClientIds]="activePassesAllowedClientIds" />